<template>
  <div class="home">
    <!--<img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <UserId/>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import UserId from '@/components/Campaigns.vue'

export default {
  name: 'Campaigns',
  components: {
    UserId
  }
}
</script>
